<template>
  <section class="wed_section_innerpage">
    <div class="container text-center wed_great_titles">
      <div class="row">
        <transition name="fade" mode="out-in">
          <div class="col-md-8 col-md-pull-2 col-md-push-2 col-sm-12" v-if="!sent" key="1">
            <h2 class="wed_form_txt">Be our guest!</h2>
            <form id="rsvp_form" class="wed_form" @submit="checkForm">
              <div class="row">
                <div class="col-md-12">
                  <input
                    v-model="name"
                    type="text"
                    class="form-control"
                    placeholder="Name"
                    name="name"
                    required
                  >
                </div>
                <div class="col-md-12">
                  <input
                    v-model="email"
                    type="text"
                    class="form-control"
                    placeholder="E-mail"
                    name="email"
                  >
                </div>
                <div class="col-md-12">
                  <select class="form-control" name="guests" required v-model="numberOfGuests">
                    <option v-for="(op, index) in invitesList" :key="index" :value="index">{{op === '0' ? 'Not Attending' : op}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <textarea
                    class="form-control"
                    placeholder="Message"
                    name="message"
                    v-model="message"
                  ></textarea>
                  <div class="col-md-4"></div>
                  <button
                    class="btn btn_new wed_btn_margbot col-md-4"
                    type="submit"
                  >Send</button>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-8 col-md-pull-2 col-md-push-2 col-sm-12" v-if="sent" key="2">
            <h2 class="wed_form_txt">Your RSVP is confirmed!</h2>
          </div>
        </transition>
        <!-- col end -->
      </div>
      <!-- row end -->
    </div>
    <!-- container end -->
  </section>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      name: '',
      message: '',
      numberOfGuests: 1,
      email: '',
      sent: false,
      listOfGuests: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
    };
  },
  methods: {
    submitRSVP() {
      event.preventDefault();
      const data = {
        name: this.name,
        numberOfGuests: this.numberOfGuests,
        email: this.email,
        message: this.message,
      };
      axios
        .post('https://us-central1-minas-wedding.cloudfunctions.net/rsvp', data)
        .then((response) => {
          this.sent = true;
        })
        .catch((error) => {
          this.sent = false;
        });
    },
    checkForm(e) {
      if (this.name) {
        this.submitRSVP();
      }

      this.errors = [];

      if (!this.name) {
        this.errors.push('Name required.');
      }
      e.preventDefault();
    },
  },
  computed: {
    invitesList() {
      let maxInvites = parseInt(this.$route.query.invites, 10);
      if (maxInvites === undefined || !maxInvites || maxInvites === 0) {
        maxInvites = 3;
      }
      return this.listOfGuests.slice(0, maxInvites + 1);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
